<template>
  <div v-if="readonly">
    <slot name="value" v-bind="{ friendlyValue }"><label v-if="!hideLabel" class="col-form-label">{{labelWithSuffix}}</label><p v-if="showValue" class="font-bold">{{friendlyValue}}</p></slot>
  </div>
  <div v-else>
    <ValidationProvider :vid="vid" :name="name" :rules="realRules" ref="valprov" :disabled="disableValidation" :custom-messages="customMessages">
      <b-form-group
        slot-scope="{ dirty, invalid, valid, validated, errors }"
        :label="labelWithSuffix"
        :label-sr-only="hideLabel"
        :label-for="$attrs.id"
        :description="description"
      >
        <b-form-checkbox-group
          v-model="innerValue"
          :options="options"
          :id="$attrs.id"
          :name="name"
          :stacked="stacked"
          :state="getValidationState(dirty, validated, valid)"
          @input="onInput(invalid)"
        ></b-form-checkbox-group>
        <slot name="feedback" v-bind="{ valid, errors }">
          <b-form-invalid-feedback :state="valid"><span v-for="(error, idx) in errors" :key="idx">{{ error }}</span></b-form-invalid-feedback>
        </slot>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>
<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import s from 'underscore.string'
import '@/shared/validations.js'

export default {
  inheritAttrs: false,
  props: {
    error: {
      type: String,
    },
    vid: {
      type: String
    },
    stacked: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return [
          { value: 1, text: 'Yes' },
          { value: 0, text: 'No' }
        ]
      }
    },
    rules: {
      type: Object|String
    },
    disableValidation: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    description: {
      type: String
    },
    // must be included in props
    value: {
      type: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    innerValue: [],
    forcedState: null
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  computed: {
    customMessages() {
      if (this.error) {
        return {
          'required': this.error,
          'is': this.error,
          'is_not': this.error
        }
      }
    },
    friendlyValue() {
      let friendly = []
      Array.prototype.forEach.call(this.options, (option) => {
        if (this.innerValue.includes(option)) {
          friendly.push(option)
        }
      })
      return friendly.join(', ')
    },
    labelWithSuffix() {
      return this.label + '*'
    },
    labelValue() {
      if (this.hideLabel) {
        return
      }
      if (this.label)
        return this.label
      return s(this.field).humanize().value()
    },
    showValue() {
      return this.innerValue.toString().length > 0
    },
    realRules() {
      if (this.rules) {
        return this.rules
      }
      return {
        required: true
      }
    }
  },
  methods: {
    getValidationState(dirty, validated, valid) {
      return dirty || validated ? valid: null
    },
    onInput(e, valid) {
      if (valid) {
        this.$parent.$emit('input', e)
      }
    }
  }
}
</script>
